<template>
  <v-row>
    <v-col class="pl-sm-4 pr-sm-4" cols="12">
      <v-card flat class="rounded-lg" color="white">
        <v-card-text>
          <v-col class="pa-0" cols="12">
            <tk-table :hasAdd="true" :hasDelete="true" ref="table" :headers="headers" :hide_footer="true">
              <template v-slot:additional="{item}">
                <v-btn :to="{name: 'edit_cook' , params:{cook_id : item._id}}" icon>
                  <iconly size="20" name="editsquare" type="light" color="grey" />
                </v-btn>
              </template>
            </tk-table>
          </v-col>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
  import {
    mapActions,
    mapGetters,
    mapMutations
  } from "vuex";

  export default {
    data() {
      return {
        switch1: false,
        newPass: '',
        OpenModal: false,
        UserId: '',
        model: null,
        headers: [
          {
            text: 'نام',
            value: 'title'
          },
          {
            text: 'دسته بندی',
            value: 'category'
          },
          {
            text: "شناسه",
            value: '_id',
            hidden: true
          },
          {
            text: "زبان",
            value: 'lang',
          },
          {
            text: "اقدامات",
            value: 'actions',
          },
        ],
        thisItem: {},
        filters : [],
        loader: false
      }
    },
    created() {
      if (this.$route.query.new) {
        this.dialog = true
      }
      this.setTableHeads(this.headers);
      this.setFilters(this.filters);
      this.setPageTitle("آشپزی");
      this.setModule("cook");
      this.setGroupHeaders([]);
    },
    methods: {
      ...mapMutations([
        "setPageTitle",
        "setFilters",
        "setTableHeads",
        "setModule",
        "setGroupHeaders",
      ]),
    }
  }
</script>
